var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.991,
    height: 32.988,
    viewBox: "0 0 26.991 32.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    "data-name": "Path 10427",
    d: "M20.994,3H9A3,3,0,0,0,6,6V29.989a3,3,0,0,0,3,3H26.992a3,3,0,0,0,3-3V12Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10428",
    "data-name": "Path 10428",
    d: "M21,3v9h9",
    transform: "translate(-0.006 0)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10429",
    "data-name": "Path 10429",
    d: "M24,19.5H12",
    transform: "translate(-0.002 -0.006)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10430",
    "data-name": "Path 10430",
    d: "M24,25.5H12",
    transform: "translate(-0.002 -0.009)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10431",
    "data-name": "Path 10431",
    d: "M15,13.5H12",
    transform: "translate(-0.002 -0.004)",
    fill: "none",
    stroke: "#d5d5d5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconGray);
export default __webpack_public_path__ + "static/media/FileIconGray.fc8fd2d00fc4cd96c3707ab26a7acf8c.svg";
export { ForwardRef as ReactComponent };